import vue from "vue";
import router from "vue-router";

import Login from "./views/Login";
import Licensing from "./views/License";
import Signup from "./views/Signup";
import Signout from "./views/Signout";
import NewVps from "./views/NewVps";
import ManageVps from "./views/ManageVps";

vue.use(router);

export default new router({
  mode: "history",
  linkExactActiveClass: "is-active",
  linkActiveClass: "is-active",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "",
      component: Login
    },
    {
      path: "/signout",
      name: "signout",
      component: Signout
    },
    {
      path: "/signup",
      name: "signup",
      component: Signup
    },
    {
      path: "/signin",
      name: "signin",
      component: Login
    },
    {
      path: "/resetpassword",
      name: "resetpassword",
      component: () => import("./views/Resetpassword.vue")
    },
    {
      path: "/resetpassword/:autoChallange",
      name: "newpassword",
      component: () => import("./views/Newpassword.vue")
    },
    {
      path: "/users",
      name: "users",
      component: () => import("./views/Users.vue")
    },
    {
      path: "/groups",
      name: "groups",
      component: () => import("./views/Groups.vue")
    },
    {
      path: "/roles",
      name: "roles",
      component: () => import("./views/Roles.vue")
    },
    {
      path: "/rules",
      name: "rules",
      component: () => import("./views/Rules.vue")
    },

    {
      path: "/servers",
      name: "servers",
      component: () => import("./views/Servers.vue")
    },
    {
      path: "/subscriptions/computers",
      name: "computerSubscriptions",
      component: () => import("./views/ComputerSubscriptions.vue")
    },
    {
      path: "/subscriptions/vps",
      name: "vpsSubscriptions",
      component: () => import("./views/VpsSubscriptions.vue")
    },
    {
      path: "/invoicing",
      name: "invocing",
      component: () => import("./views/Invoicing.vue")
    },
    {
      path: "/instructions",
      name: "instructions",
      component: () => import("./views/Instructions.vue")
    },
    {
      path: "/licensing",
      name: "licensing",
      component: Licensing
    },
    {
      path: "/subscriptions/vps/manage/:uid",
      name: "managevps",
      component: ManageVps
    },
    {
      path: "/tax-report/:payoutId?",
      component: () => import("./views/TaxReport.vue")
    }
    // {
    //   //LAZY LOADING
    //   path: "/about",
    //   name: "about",
    //   component: () => import("./views/About.vue")
    // }
  ]
});
